import Vue from 'vue';

export default {
  namespaced: true,

  state: {
    runningExperiments: [
      'p0ht7U2BRtK5oXDPk9U2zA',
    ],
    testVariants: {},
  },

  actions: {
    initializeAllExperiments({ state, commit }) {
      state.runningExperiments.forEach((experiment) => {
        commit('setExperiment', {
          name: experiment,
          value: window.google_optimize.get(experiment),
        });
      });
    },
  },

  getters: {
    getExperimentVariant: (state) => (name) => {
      if (!state.testVariants[name]) {
        return 0;
      }

      return state.testVariants[name];
    },
  },

  mutations: {
    setExperiment(state, { name, value }) {
      if (value === undefined) {
        value = 0;
      }

      if (state.testVariants[name] !== parseInt(value)) {
        Vue.set(state.testVariants, name, parseInt(value));
        // eslint-disable-next-line
        console.info('AB : ' + name + ' - Variant ' + parseInt(value));
      }
    },
  },
};

let timeoutMultiplier = 1;

export function initializeGoogleOptimize(store) {
  if (typeof window.gtag !== 'function') {
    if (window.dataLayer === undefined) {
      window.dataLayer = [];
    }

    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
  }

  if (
    typeof window.google_optimize === 'object' &&
    typeof window.google_optimize.get === 'function'
  ) {
    store.dispatch('ABTesting/initializeAllExperiments');
    window.gtag('event', 'optimize.callback', {
      callback: (value, name) => {
        store.commit('ABTesting/setExperiment', {
          name,
          value,
        });
      },
    });
  } else {
    setTimeout(() => {
      timeoutMultiplier++;
      initializeGoogleOptimize(store);
    }, 100 * timeoutMultiplier);
  }
}
